class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ].filter((section) => document.getElementById(section.id) || (section.selector && document.querySelector(section.selector)));
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ].filter((section) => document.getElementById(section.id) || (section.selector && document.querySelector(section.selector)));
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// /* ============================================
//    CART DRAWER RECOMMENDATIONS
//    ============================================ */
// (function () {
//   var RECS_LIMIT = 10;

//   function getCartProductIds() {
//     return fetch('/cart.json')
//       .then(function (res) { return res.json(); })
//       .then(function (cart) {
//         var ids = [];
//         cart.items.forEach(function (item) {
//           if (ids.indexOf(item.product_id) === -1) {
//             ids.push(item.product_id);
//           }
//         });
//         return ids;
//       });
//   }

//   function fetchRecommendations(productId) {
//     // Use "related" intent
//     return fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + RECS_LIMIT + '&intent=related')
//       .then(function (res) { return res.json(); })
//       .then(function (data) { return data.products || []; })
//       .catch(function () { return []; });
//   }

//   function formatMoney(cents) {
//     return '$' + (cents / 100).toFixed(2);
//   }

//   function renderRecommendations(products, cartProductIds) {
//     var container = document.getElementById('CartDrawer-RecommendationsList');
//     if (!container) return;

//     // Filter out: products already in cart, warranty products, missing images
//     var filtered = products.filter(function (p) {
//       if (cartProductIds.indexOf(p.id) !== -1) return false;
//       // Filter out warranty/service products (no image or vendor is Surebright)
//       if (p.vendor && p.vendor.toLowerCase() === 'surebright') return false;
//       if (!p.featured_image) return false;
//       // Note: We DO NOT filter out !p.available anymore so sold-out products still show
//       return true;
//     });

//     var recsWrapper = document.getElementById('CartDrawer-Recommendations');
//     if (!recsWrapper) return;

//     if (filtered.length === 0) {
//       recsWrapper.style.display = 'none';
//       return;
//     }

//     recsWrapper.style.display = '';

//     var html = '';
//     filtered.forEach(function (product) {
//       var image = product.featured_image || '';
//       // Fix protocol-relative URLs
//       if (image.indexOf('//') === 0) image = 'https:' + image;
//       var variantId = product.variants && product.variants[0] ? product.variants[0].id : '';
//       var price = product.variants && product.variants[0] ? product.variants[0].price : product.price;
//       var comparePrice = product.variants && product.variants[0] ? product.variants[0].compare_at_price : null;
//       var isAvailable = product.variants && product.variants[0] ? product.variants[0].available : product.available;

//       html += '<div class="cart-drawer__recommendation-card">';
//       html += '  <a href="' + product.url + '" tabindex="-1">';
//       html += '    <img src="' + image + '&width=300" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="150" height="150">';
//       html += '  </a>';
//       html += '  <div class="cart-drawer__recommendation-info">';
//       html += '    <a href="' + product.url + '" class="cart-drawer__recommendation-title">' + product.title + '</a>';
//       html += '    <div class="cart-drawer__recommendation-price">';
//       if (comparePrice && comparePrice > price) {
//         html += '      <s style="opacity:0.5;font-weight:400;margin-right:0.5rem">' + formatMoney(comparePrice) + '</s>';
//       }
//       html += formatMoney(price);
//       html += '    </div>';
      
//       // Show "Sold out" if not available
//       if (isAvailable) {
//         html += '    <button class="cart-drawer__recommendation-add" data-variant-id="' + variantId + '">Add</button>';
//       } else {
//         html += '    <button class="cart-drawer__recommendation-add" disabled>Sold out</button>';
//       }
//       html += '  </div>';
//       html += '</div>';
//     });

//     container.innerHTML = html;

//     // Bind "Add" buttons
//     container.querySelectorAll('.cart-drawer__recommendation-add:not([disabled])').forEach(function (btn) {
//       btn.addEventListener('click', function () {
//         var variantId = btn.getAttribute('data-variant-id');
//         if (!variantId) return;

//         btn.disabled = true;
//         btn.textContent = 'Adding...';

//         var formData = { items: [{ id: parseInt(variantId), quantity: 1 }] };

//         fetch('/cart/add.json', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//           body: JSON.stringify(formData)
//         })
//           .then(function (res) { return res.json(); })
//           .then(function () {
//             btn.textContent = 'Added ✓';
//             btn.classList.add('added');

//             // Refresh the cart drawer contents
//             var cartDrawer = document.querySelector('cart-drawer');
//             if (cartDrawer) {
//               var sectionsToFetch = ['cart-drawer', 'cart-icon-bubble'];
//               fetch(routes.cart_url + '?sections=' + sectionsToFetch.join(','))
//                 .then(function (res) { return res.json(); })
//                 .then(function (sections) {
//                   var drawerHTML = sections['cart-drawer'];
//                   if (drawerHTML) {
//                     var parsed = new DOMParser().parseFromString(drawerHTML, 'text/html');
//                     var newInner = parsed.querySelector('.drawer__inner');
//                     var currentInner = document.querySelector('#CartDrawer .drawer__inner');
//                     if (newInner && currentInner) {
//                       currentInner.innerHTML = newInner.innerHTML;
//                     }
//                   }
//                   var bubbleHTML = sections['cart-icon-bubble'];
//                   if (bubbleHTML) {
//                     var parsed2 = new DOMParser().parseFromString(bubbleHTML, 'text/html');
//                     var newBubble = parsed2.querySelector('.shopify-section');
//                     var currentBubble = document.getElementById('cart-icon-bubble');
//                     if (newBubble && currentBubble) {
//                       currentBubble.innerHTML = newBubble.innerHTML;
//                     }
//                   }
//                   // Re-load recommendations after cart update
//                   loadCartRecommendations();
//                 });
//             }
//           })
//           .catch(function () {
//             btn.textContent = 'Error';
//             btn.disabled = false;
//           });
//       });
//     });
//   }

//   function loadCartRecommendations() {
//     getCartProductIds().then(function (cartProductIds) {
//       if (cartProductIds.length === 0) return;

//       // Try each product in cart until we find recommendations
//       var tryProduct = function(index) {
//         if (index >= cartProductIds.length) {
//           // No recommendations found for any product — hide section
//           var recsWrapper = document.getElementById('CartDrawer-Recommendations');
//           if (recsWrapper) recsWrapper.style.display = 'none';
//           return;
//         }
//         fetchRecommendations(cartProductIds[index]).then(function (products) {
//           // Filter same as render to check if we'd actually show anything
//           var validProducts = products.filter(function(p) {
//             if (cartProductIds.indexOf(p.id) !== -1) return false;
//             if (p.vendor && p.vendor.toLowerCase() === 'surebright') return false;
//             if (!p.featured_image) return false;
//             return true;
//           });
//           if (validProducts.length > 0) {
//             renderRecommendations(products, cartProductIds);
//           } else {
//             tryProduct(index + 1);
//           }
//         });
//       };
//       tryProduct(0);
//     });
//   }

//   // Load recommendations when cart drawer opens
//   var originalOpen = CartDrawer.prototype.open;
//   CartDrawer.prototype.open = function (triggeredBy) {
//     originalOpen.call(this, triggeredBy);
//     loadCartRecommendations();
//   };

//   // Refresh when cart contents are rendered (add to cart from PDP)
//   var originalRender = CartDrawer.prototype.renderContents;
//   CartDrawer.prototype.renderContents = function (parsedState) {
//     originalRender.call(this, parsedState);
//     setTimeout(loadCartRecommendations, 300);
//   };

//   // Also reload after quantity change replaces drawer HTML
//   if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
//     subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
//       setTimeout(loadCartRecommendations, 500);
//     });
//   }
// })();

/* ============================================
   CART DRAWER RECOMMENDATIONS (SEARCH API VERSION)
   ============================================ */
(function () {
  function getCartProductIds() {
    return fetch('/cart.json')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var ids = [];
        cart.items.forEach(function (item) {
          if (ids.indexOf(item.product_id) === -1) {
            ids.push(item.product_id);
          }
        });
        return ids;
      });
  }

  function fetchRecommendations() {
    return fetch('/search/suggest.json?q=*&resources[type]=product&resources[limit]=10')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.resources && data.resources.results && data.resources.results.products) {
          return data.resources.results.products;
        }
        return [];
      })
      .catch(function () { return []; });
  }

  function renderRecommendations(products, cartProductIds) {
    var container = document.getElementById('CartDrawer-RecommendationsList');
    if (!container) return;

    var filtered = products.filter(function (p) {
      if (cartProductIds.indexOf(p.id) !== -1) return false;
      if (p.vendor && p.vendor.toLowerCase() === 'surebright') return false;
      if (!p.featured_image && !p.image) return false;
      // Hide sold-out products
      if (!p.available) return false;
      return true;
    });

    var recsWrapper = document.getElementById('CartDrawer-Recommendations');
    if (!recsWrapper) return;

    if (filtered.length === 0) {
      recsWrapper.style.display = 'none';
      return;
    }

    recsWrapper.style.display = '';

    var html = '';
    filtered.forEach(function (product) {
      var image = product.image || (product.featured_image ? product.featured_image.url : '') || '';
      if (typeof image === 'string' && image.indexOf('//') === 0) image = 'https:' + image;
      
      var variantId = product.variants && product.variants[0] ? product.variants[0].id : '';
      var price = product.price; 
      var comparePrice = product.compare_at_price_min || null;
      var isAvailable = product.available;
      
      var displayPrice = price;
      if (!price.toString().includes('$')) {
        displayPrice = '$' + price;
      }

      html += '<div class="cart-drawer__recommendation-card">';
      html += '  <a href="' + product.url + '" tabindex="-1">';
      html += '    <img src="' + image + '&width=300" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="150" height="150">';
      html += '  </a>';
      html += '  <div class="cart-drawer__recommendation-info">';
      html += '    <a href="' + product.url + '" class="cart-drawer__recommendation-title">' + product.title + '</a>';
      html += '    <div class="cart-drawer__recommendation-price">';
      if (comparePrice && comparePrice > price) {
        html += '      <s style="opacity:0.5;font-weight:400;margin-right:0.5rem">$' + comparePrice + '</s>';
      }
      html += displayPrice;
      html += '    </div>';
      
      if (isAvailable) {
        html += '    <button class="cart-drawer__recommendation-add" data-variant-id="' + variantId + '">Add</button>';
      } else {
        html += '    <button class="cart-drawer__recommendation-add" disabled>Sold out</button>';
      }
      html += '  </div>';
      html += '</div>';
    });

    container.innerHTML = html;

    container.querySelectorAll('.cart-drawer__recommendation-add:not([disabled])').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.disabled = true;
        btn.textContent = 'Adding...';

        var formData = { items: [{ id: parseInt(variantId), quantity: 1 }] };

        fetch('/cart/add.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(formData)
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            btn.textContent = 'Added ✓';
            btn.classList.add('added');

            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              var sectionsToFetch = ['cart-drawer', 'cart-icon-bubble'];
              fetch(routes.cart_url + '?sections=' + sectionsToFetch.join(','))
                .then(function (res) { return res.json(); })
                .then(function (sections) {
                  var drawerHTML = sections['cart-drawer'];
                  if (drawerHTML) {
                    var parsed = new DOMParser().parseFromString(drawerHTML, 'text/html');
                    var newInner = parsed.querySelector('.drawer__inner');
                    var currentInner = document.querySelector('#CartDrawer .drawer__inner');
                    if (newInner && currentInner) {
                      currentInner.innerHTML = newInner.innerHTML;
                    }
                  }
                  var bubbleHTML = sections['cart-icon-bubble'];
                  if (bubbleHTML) {
                    var parsed2 = new DOMParser().parseFromString(bubbleHTML, 'text/html');
                    var newBubble = parsed2.querySelector('.shopify-section');
                    var currentBubble = document.getElementById('cart-icon-bubble');
                    if (newBubble && currentBubble) {
                      currentBubble.innerHTML = newBubble.innerHTML;
                    }
                  }
                  loadCartRecommendations();
                });
            }
          })
          .catch(function () {
            btn.textContent = 'Error';
            btn.disabled = false;
          });
      });
    });
  }

  function loadCartRecommendations() {
    getCartProductIds().then(function (cartProductIds) {
      if (cartProductIds.length === 0) return;

      fetchRecommendations().then(function (products) {
        var validProducts = products.filter(function(p) {
          if (cartProductIds.indexOf(p.id) !== -1) return false;
          if (p.vendor && p.vendor.toLowerCase() === 'surebright') return false;
          if (!p.featured_image && !p.image) return false;
          // Hide sold-out products
          if (!p.available) return false;
          return true;
        });

        if (validProducts.length > 0) {
          renderRecommendations(products, cartProductIds);
        } else {
          var recsWrapper = document.getElementById('CartDrawer-Recommendations');
          if (recsWrapper) recsWrapper.style.display = 'none';
        }
      });
    });
  }

  var originalOpen = CartDrawer.prototype.open;
  CartDrawer.prototype.open = function (triggeredBy) {
    originalOpen.call(this, triggeredBy);
    loadCartRecommendations();
  };

  var originalRender = CartDrawer.prototype.renderContents;
  CartDrawer.prototype.renderContents = function (parsedState) {
    originalRender.call(this, parsedState);
    setTimeout(loadCartRecommendations, 300);
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(loadCartRecommendations, 500);
    });
  }
})();

